{
  "newCampaign": "Nuova campagna",
  "firmware": {
    "update": {
      "label": "Aggiornamento del firmware",
      "description": "Parametrizzare la data e l’ora della procedura di avvio dell’aggiornamento del firmware dell’{name}",
      "firmwareLabel": "Firmware",
      "uuidRequired": "Il firmware è obbligatorio",
      "plannedStartAt": "Data di aggiornamento del firmware (GG/MM/AAAA HH:MM)",
      "notaBene": "L’aggiornamento del firmware sarà effettuato durante la prossima comunicazione con l’{name} a partire dalla data di aggiornamento del firmware stesso.",
      "dateTimeError": "Il campo della data è richiesto per l’aggiornamento del firmware",
      "firmwareSelection": "Selezionare un firmware nell’elenco qui sopra",
      "FirmwareSelectionRequired": "È necessario selezionare un firmware nell’elenco",
      "warningMessage": "Attenzione: l’aggiornamento del firmware comporterà il riavvio degli apparati interessati alla fine dell’aggiornamento."
    }
  },
  "dateInferiorToToday": "La data non deve essere inferiore alla data/ora attuale",
  "dateInferiorToDate": "La data non deve essere inferiore al {date}",
  "dateFormat": "DD/MM/YYYY HH:mm",
  "confirm": "Confermare",
  "cancel": "Annulla",
  "list": {
    "column": {
      "name": {
        "label": "Campagna"
      },
      "type": {
        "label": "Tipo",
        "CRTCLT_RENEWAL_DVC": "Rinnovo dei certificati degli apparati",
        "CRTCLT_RENEWAL_APP": "Rinnovo dei certificati delle applicazioni",
        "FIRMWARE_UPGRADE_DVC": "Aggiornamento dei firmware degli apparati"
      },
      "dates": {
        "label": "Date",
        "format": "DD/MM/YYYY"
      },
      "numberOfEquipments": {
        "label": "Numero di apparati",
        "value": "{count} apparato | {count} apparato | {count} apparati"
      },
      "status": {
        "label": "Stato",
        "value": {
          "SCHEDULED": "Pianificato",
          "RUNNING": "In corso",
          "PAUSED": "In pausa",
          "COMPLETE": "Terminata",
          "COMPLETE_WITH_ERRORS": "Errore",
          "INCOMPLETE": "Errore",
          "PLATFORM_ERROR": "Errore",
          "CANCELLING": "Annullamento",
          "CANCELLED": "Annullata",
          "UNKNOWN": "Sconosciuto",
          "DRAFT": "Bozza"
        }
      },
      "pending": {
        "label": "In attesa"
      },
      "inProgress": {
        "label": "In corso"
      },
      "success": {
        "label": "Riuscita"
      },
      "failed": {
        "label": "Non riuscita"
      },
      "numberOfDevice": {
        "label": "Numero di apparati",
        "value": "{count} apparati | {count} apparato | {count} apparati"
      },
      "operations": "Operazioni",
      "done": {
        "label": "Fatto"
      }
    },
    "empty": "Non è stata trovata nessuna campagna"
  },
  "details": {
    "buttons": {
      "update": {
        "label": "Modificare"
      },
      "cancel": {
        "label": "Annullare la campagna",
        "confirm": {
          "message": "Confermare l’annullamento della campagna?",
          "title": "Annullare la campagna",
          "yes": "Sì",
          "no": "No"
        }
      },
      "edit": {
        "label": "Modifica"
      }
    },
    "properties": {
      "title": "Proprietà",
      "name": {
        "label": "Nome"
      },
      "type": {
        "label": "Tipo",
        "CRTCLT_RENEWAL_DVC": "Rinnovo dei certificati degli apparati",
        "CRTCLT_RENEWAL_APP": "Rinnovo dei certificati delle applicazioni",
        "FIRMWARE_UPGRADE_DVC": "Aggiornamento dei firmware degli apparati"
      },
      "dates": {
        "label": "Date"
      },
      "state": {
        "label": "Stato"
      }
    },
    "characteristics": {
      "title": "Caratteristiche",
      "createdBy": "Creato da",
      "type": {
        "label": "Tipo:",
        "value": {
          "CRTCLT_RENEWAL_DVC": "Rinnovo dei certificati degli apparati",
          "CRTCLT_RENEWAL_APP": "Rinnovo dei certificati delle applicazioni",
          "FIRMWARE_UPGRADE_DVC": "Aggiornamento dei firmware degli apparati"
        }
      },
      "status": {
        "label": "Stato:",
        "value": {
          "SCHEDULED": "Pianificato",
          "RUNNING": "In corso",
          "PAUSED": "In pausa",
          "COMPLETE": "Terminata",
          "COMPLETE_WITH_ERRORS": "Errore",
          "INCOMPLETE": "Errore",
          "PLATFORM_ERROR": "Errore",
          "CANCELLING": "Annullamento",
          "CANCELLED": "Annullata"
        }
      },
      "lifeCyle": {
        "creation": "Creazione: {value}",
        "launch": "Avvio: {value}",
        "closing": "Chiusura: {value}"
      },
      "inclusionPeriods": {
        "title": "Periodi di inclusione",
        "inactive": "inattivo",
        "monday": "Lunedì: {value}",
        "tuesday": "Martedì: {value}",
        "wednesday": "Mercoledì: {value}",
        "thursday": "Giovedì: {value}",
        "friday": "Venerdì: {value}",
        "saturday": "Sabato: {value}",
        "sunday": "Domenica: {value}"
      },
      "equipments": {
        "title": "{count} apparati | {count} apparato | {count} apparati",
        "status": {
          "pending": "In attesa: {percent}, {count} apparati | In attesa: {percent}, {count} apparato | In attesa: {percent}, {count} apparati",
          "running": "In corso: {percent}, {count} apparati | In corso: {percent}, {count} apparato | In corso: {percent}, {count} apparati",
          "complete": "Operazione riuscita: {percent}, {count} apparati | Operazione riuscita: {percent}, {count} apparato | Operazione riuscita: {percent}, {count} apparati",
          "failed": "Operazione non riuscita: {percent}, {count} apparati | Operazione non riuscita: {percent}, {count} apparato | Operazione non riuscita: {percent}, {count} apparati"
        },
        "statistics": {
          "title": "{count} apparati | {count} apparato | {count} apparati"
        }
      },
      "devices": {
        "status": {
          "scheduled": "Programmati: {percent}, {count} apparati | Programmati: {percent}, {count} apparato | Programmati: {percent}, {count} apparati",
          "completed": "Completati: {percent}, {count} apparati | Completati: {percent}, {count} apparato | Completati: {percent}, {count} apparati",
          "error": "Errore: {percent}, {count} apparati | Errore: {percent}, {count} apparato | Errore: {percent}, {count} apparati",
          "running": "In corso: {percent}, {count} apparati | In corso: {percent}, {count} apparato | In corso: {percent}, {count} apparati"
        }
      },
      "operationType": "Tipo:"
    },
    "equipments": {
      "title": "Elenco degli apparati",
      "column": {
        "label": {
          "label": "Apparato"
        },
        "deviceType": {
          "label": "Tipo di apparato"
        },
        "message": {
          "label": "Stato dell’operazione"
        },
        "startDate": {
          "label": "Data di avviamento dell’operazione",
          "format": "DD/MM/YYYY HH:mm"
        },
        "lastOperationDate": {
          "label": "Data dell’ultima operazione",
          "format": "DD/MM/YYYY HH:mm"
        },
        "name": {
          "label": "Etichetta"
        },
        "serialNumber": {
          "label": "Numero seriale"
        },
        "firmware": {
          "label": "Firmware"
        },
        "connectivity": {
          "label": "Connettività"
        },
        "metastatus": {
          "label": "Metastato"
        },
        "sector": {
          "label": "Rete"
        },
        "lastUpdate": {
          "label": "Ultima data aggiornata"
        },
        "operationStatus": {
          "label": "Stato operativo"
        }
      },
      "empty": "Non è stato trovato nessun apparato",
      "states": {
        "WITHDRAWN": "Rimosso",
        "DEACTIVATED": "Disattivato",
        "DELETED": "Eliminato"
      }
    },
    "status": {
      "title": "Stato campagna"
    },
    "cancel": {
      "error": "Si è verificato un errore durante l’annullamento della campagna.",
      "success": "L’annullamento della campagna è stato avviato con successo."
    }
  },
  "form": {
    "campaignSettings": {
      "title": "Parametrizzazione della campagna",
      "name": "Nome della campagna",
      "typeOfCampaign": {
        "title": "Tipo di campagna",
        "firmwareUpdate": {
          "title": "Campagna di aggiornamento del firmware",
          "option": "Aggiornamento dei firmware degli apparati",
          "label": "Nome del firmware",
          "dependencies": "Dipendenze"
        },
        "deviceCertificateRenewal": "Rinnovo dei certificati degli apparati",
        "applicationCertificateRenewal": "Rinnovo dei certificati delle applicazioni"
      },
      "validation": {
        "name": "Il nome della campagna è obbligatorio",
        "type": "Il tipo di campagna è obbligatorio",
        "firmwareUuid": "Il firmware è obbligatorio"
      }
    },
    "fleetSelection": {
      "title": "Selezione della flotta di apparati",
      "devices": "Apparati",
      "applications": "Applicazioni",
      "validation": {
        "required": "La selezione di almeno un apparato è obbligatoria"
      },
      "actions": {
        "scheduled": {
          "confirm": {
            "title": "Azioni in corso esistenti",
            "message": "Alcuni apparati selezionati possiedono già delle azioni in corso. Continuare?",
            "yes": "Sì",
            "no": "No"
          }
        }
      }
    },
    "campaignPlanification": {
      "title": "Pianificazione della campagna",
      "executionDates": {
        "title": "Date di esecuzione della campagna",
        "plannedStartAt": "Inizio della campagna",
        "endDate": "Fine della campagna",
        "validation": {
          "plannedStartAt": "La data di inizio della campagna è obbligatoria",
          "plannedEndAt": "La data di fine della campagna è obbligatoria",
          "startDateNotBeyondLicenseExpirationDateTolerancy": "La data di avvio della campagna non può essere posteriore alla data di scadenza della licenza",
          "endDateNotBeyondLicenseExpirationDateTolerancy": "La data di fine della campagna non può essere posteriore alla data di scadenza della licenza"
        }
      },
      "inclusionPeriods": {
        "title": "Periodi di inclusione",
        "remove": "Eliminare",
        "add": "Aggiungere",
        "day": "Giorno",
        "days": {
          "monday": "lunedì",
          "tuesday": "martedì",
          "wednesday": "mercoledì",
          "thursday": "giovedì",
          "friday": "venerdì",
          "saturday": "sabato",
          "sunday": "domenica"
        },
        "validation": {
          "day": "Il giorno del periodo di inclusione è obbligatorio",
          "range": "La durata di un periodo di inclusione non può essere inferiore a 15 minuti"
        }
      }
    },
    "buttons": {
      "next": "Avanti",
      "previous": "Indietro",
      "submit": "Conferma"
    }
  },
  "report": {
    "title": "Rapporto",
    "plannedStartAt": "Data di avvio prevista:",
    "processes": {
      "column": {
        "label": "Nome",
        "status": "Stato"
      }
    }
  },
  "funnel": {
    "step": "Fase",
    "of": "di",
    "newCampaign": "Parametrizza una nuova compagna",
    "updateCampaign": "Modifica la campagna",
    "scheduling": "Pianificazione",
    "next": "Avanti",
    "previous": "Indietro",
    "publish": "Pubblica la campagna",
    "campaignSettings": {
      "title": "Scegli i parametri",
      "name": "Nome della campagna",
      "typeOfCampaign": {
        "title": "Tipo di campagna",
        "firmwareUpdate": {
          "label": "Aggiornamento del firmware",
          "title": "Campagna di aggiornamento del firmware",
          "firmwareName": "Nome del firmware"
        },
        "certificate": "Certificato",
        "deviceCertificateRenewal": "Rinnovo dei certificati degli apparati",
        "applicationCertificateRenewal": "Rinnovo dei certificati delle applicazioni",
        "configurationUpdate": {
          "selfSupporting": {
            "warningMessage": "Questa campagna sarà valida per la configurazione caricata più di recente di ogni apparato selezionato."
          }
        }
      },
      "validation": {
        "name": "Il nome della campagna è obbligatorio",
        "type": "Il tipo di campagna è obbligatorio",
        "firmwareUuid": "Il firmware è obbligatorio"
      },
      "operationModelType": {
        "CONFIG": "Parametrizzazione",
        "FIRM_UPDATE": "Aggiornamento firmware",
        "OPTIONS": "Opzioni",
        "CERT_RENEW": "Certificato"
      }
    },
    "fleetSelection": {
      "title": "Flotta di apparati",
      "validation": {
        "required": "La selezione di almeno un apparato è obbligatoria"
      },
      "actions": {
        "scheduled": {
          "confirm": {
            "title": "Azioni in corso esistenti",
            "message": "Alcuni apparati selezionati possiedono già delle azioni in corso. Continuare?",
            "yes": "Sì",
            "no": "No"
          }
        }
      },
      "devices": "Apparati",
      "fleets": "Flotte",
      "fleetInformation": {
        "title": "{fleetName} informazioni",
        "message": {
          "beginning": "Con la parametrizzazione della campagna attuale,",
          "middle": "{count} apparato nella flotta | {count} apparato nella flotta  | {count} apparati nella flotta",
          "end": "non può essere aggiornato | non può essere aggiornato | non potrà essere aggiornato"
        }
      }
    },
    "campaignPlanification": {
      "title": "Scegli le date",
      "executionDates": {
        "plannedStartAt": "Inizio della campagna",
        "endDate": "Fine della campagna",
        "validation": {
          "plannedStartAt": "La data di inizio della campagna è obbligatoria",
          "startDateNotBeyondLicenseExpirationDateTolerancy": "La data di avvio della campagna non può essere posteriore alla data di scadenza della licenza",
          "endDateNotBeyondLicenseExpirationDateTolerancy": "La data di fine della campagna non può essere posteriore alla data di scadenza della licenza",
          "plannedEndAt": "La data di fine della campagna è obbligatoria"
        }
      },
      "inclusionPeriods": {
        "title": "Periodi di inclusione",
        "subTitle": "Opzionale",
        "informations": {
          "period": "Si tratta di un periodo durante cui un apparato è autorizzato a eseguire un’azione.",
          "defaultValue": "Per default non verrà applicata nessuna restrizione all’apparato.",
          "businessHour": "Orario di ufficio (dalle 9:00 alle 18:00, dal lunedì al venerdì)",
          "weekendHour": "Fine settimana (dalle 00:00 alle 23:59, dal sabato alla domenica)"
        },
        "days": {
          "monday": "lunedì",
          "tuesday": "martedì",
          "wednesday": "mercoledì",
          "thursday": "giovedì",
          "friday": "venerdì",
          "saturday": "sabato",
          "sunday": "domenica"
        },
        "addADay": "Aggiungi un giorno",
        "add": "Aggiungi",
        "delete": "Elimina",
        "selectPlaceholder": "Seleziona un giorno",
        "start": "Inizio",
        "end": "Fine",
        "validation": {
          "day": "Il giorno del periodo di inclusione è obbligatorio",
          "start": "L’inizio del periodo di inclusione è obbligatorio",
          "end": "La fine del periodo di inclusione è obbligatoria",
          "range": "La durata di un periodo di inclusione non può essere inferiore a 15 minuti",
          "startAfterEnd": "L’ora di inizio non può essere successiva all’ora di fine",
          "endBeforeStart": "L’ora di fine non può essere precedente all’ora di inizio"
        },
        "presets": {
          "businessHours": "Orario lavorativo (dal lunedì al venerdì, dalle 9:00 alle 18:00)",
          "weekend": "Fine settimana (dal sabato alla domenica, dalle 12:00 alle 23:59)"
        }
      }
    },
    "deviceFleetSelection": {
      "title": "Flotta apparati"
    }
  },
  "operationModelType": {
    "composite": "Composito"
  },
  "operationMgr": {
    "filters": {
      "status": "Stato",
      "type": "Tipo"
    }
  }
}
